/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ClientManagementGetOtDocsGet$Plain$Params {
  otRepository?: string;
}

export function clientManagementGetOtDocsGet$Plain(http: HttpClient, rootUrl: string, params?: ClientManagementGetOtDocsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetOtDocsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('otRepository', params.otRepository, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

clientManagementGetOtDocsGet$Plain.PATH = '/ClientManagement/GetOtDocs';
